var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-company-management"},[_c('PageHeader',{attrs:{"title":_vm.$t('company')}}),_c('div',{staticClass:"pt-8"},[_c('CompanyMngTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }